import React ,{useState} from "react";
import NewAds from "../../assets/data/NewAds.js";
import Delete from "../../components/admin/popup/Delete/Delete";

function NewAdd() {
  const totalAds = NewAds.length;
  const [showDelete, setShowDelete] = useState(false);
  const [NewAdsToDelete, setNewAdsToDelete] = useState(null);

  const handleDeleteClick = (NewAds) => {
    setNewAdsToDelete(NewAds);
    setShowDelete(true);
  };

  const handleDeleteConfirm = () => {
    setNewAdsToDelete(null);
    setShowDelete(false);
  };

  const handleDeleteCancel = () => {
    setShowDelete(false);
  };

  return (
    <div className="MainDashboard flex items-center justify-between">
      <div className="Table w-[100%]  rounded-lg p-4 bg-white">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-lg font-semibold mb-2">Ads</h2>
          <div className="relative">
            <i
              className="fa fa-bell text-[24px] relative"
              aria-hidden="true"
            ></i>
            {totalAds > 0 && (
              <span className="absolute top-[-5px] right-[-5px] bg-red-600 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                {totalAds}
              </span>
            )}
          </div>
        </div>

        {/* Table Container with Scroll */}
        <div className="overflow-y-auto h-[70vh] lg:w-full md:full w-[330px]" >
          <table className="lg:w-full md:full w-[350px] border-collapse text-sm">
            {/* Sticky Table Header */}
            <thead className="sticky top-0 bg-gray-200">
              <tr className="text-gray-700">
                <th className="p-2 border-b">Client</th>
                <th className="p-2 border-b">Phone</th>
                <th className="p-2 border-b">Address</th>
                <th className="p-2 border-b">Category</th>
                <th className="p-2 border-b">Image</th>
                <th className="p-2 border-b">Action</th>
              </tr>
            </thead>
            <tbody>
              {NewAds.map((Ad) => (
                <tr className="hover:bg-gray-100" key={Ad._id}>
                  <td className="p-2 border-b text-center">{Ad.client}</td>
                  <td className="p-2 border-b text-center">{Ad.phone}</td>
                  <td className="p-2 border-b text-center">{Ad.address}</td>
                  <td className="p-2 border-b text-center">{Ad.category}</td>
                  <td className="p-2 border-b ">
                    <img src={Ad.image} alt="AdPhoto" className="w-8 h-8" />
                  </td>
                  <td className="p-2 border-b text-center  ">
                    <i
                      className="fa fa-trash text-red-600 cursor-pointer w-[20px] "
                      aria-hidden="true"
                      onClick={() => handleDeleteClick(Ad)}
                    ></i>
                    <i
                      className="fa fa-edit text-blue-600 cursor-pointer w-[20px]"
                      aria-hidden="true"
                    ></i>
                    
                  
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {showDelete && NewAdsToDelete && (
        <Delete
          image={NewAdsToDelete.image}
          name={NewAdsToDelete.client}
          onDelete={handleDeleteConfirm}
          onCancel={handleDeleteCancel}
        />
      )}
    </div>
  );
}

export default NewAdd;
